import { FlagsQueryQuery } from '@/__generated__/graphql';
import { gql } from '@/__generated__/index';

export const FlagsQuery = gql(`
  query FlagsQuery {
    flags {
      key
      value
    }
  }
`);

export const resolveFlagValue = (
  flags: FlagsQueryQuery['flags'],
  key: string,
): boolean | null => {
  const entry = flags.find((f) => f.key === key);
  if (!entry) return null;
  return entry.value != null && entry.value !== 'false';
};

export const resolveFlagRawValue = (
  flags: FlagsQueryQuery['flags'],
  key: string,
): string | null => {
  const entry = flags.find((f) => f.key === key);
  return entry?.value ?? null;
};
